import React, { useState } from "react";
import ListIcon from '@mui/icons-material/List';
import SearchIcon from '@mui/icons-material/Search';
import ArticleIcon from '@mui/icons-material/Article';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import SettingsIcon from '@mui/icons-material/Settings';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import { useDispatch } from "react-redux";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { setGuideNavSelection } from "../../../../../slices/sessionDataSlice";
import {
  GuideNavItem,
  GuideNavList,
  GuideSubNavGroup,
  GuideSubNavItem,
} from "./GuideWorkspaceComponents";

const GuideNavigation = ({navSelection}) => {
  const dispatch = useDispatch()

  const [lastLeadGuide, setLastLeadGuide] = useState('overview');

  const changeSelection = (remember, content) => {
    if (remember) {
      if (content === 'leadOverview') {
        setLastLeadGuide('overview')
      } else if (content === 'investigatingLeads') {
        setLastLeadGuide('investigating')
      } else if (content === 'closingLeads') {
        setLastLeadGuide('closing')
      }
    }
    dispatch( setGuideNavSelection(content) )
  }
  const handleShowLeadGuide = () => {
    if (lastLeadGuide === 'overview') {
      changeSelection(true, 'leadOverview')
    } else if (lastLeadGuide === 'investigating') {
      changeSelection(true, 'investigatingLeads')
    } else if (lastLeadGuide === 'closing') {
      changeSelection(true, 'closingLeads')
    }
  }

  const leadSelected =
    navSelection === "leadOverview" ||
    navSelection === "investigatingLeads" ||
    navSelection === "closingLeads";

  const renderNavItem = ({ label, icon, active, onClick }) => (
    <GuideNavItem
      type="button"
      className={active ? "active" : ""}
      disabled={active}
      onClick={active ? undefined : onClick}
      aria-current={active ? "page" : undefined}
    >
      {icon}
      <span>{label}</span>
    </GuideNavItem>
  );

  const renderSubNavItem = ({ id, index, label }) => {
    const active = navSelection === id;

    return (
      <GuideSubNavItem
        type="button"
        className={active ? "active" : ""}
        disabled={active}
        onClick={active ? undefined : () => changeSelection(true, id)}
        aria-current={active ? "page" : undefined}
      >
        <span className="index">{index}</span>
        <span>{label}</span>
      </GuideSubNavItem>
    );
  };

  return (
    <GuideNavList aria-label="Guide subjects">
      {renderNavItem({
        id: "introduction",
        label: "Introduction",
        icon: <LooksOneIcon />,
        active: navSelection === "introduction",
        onClick: () => changeSelection(false, "introduction"),
      })}

      {renderNavItem({
        id: "leadGuide",
        label: "Investigation Management",
        icon: <FlagCircleIcon />,
        active: leadSelected,
        onClick: handleShowLeadGuide,
      })}

      <GuideSubNavGroup>
        {renderSubNavItem({
          id: "leadOverview",
          index: "i.",
          label: "Overview",
        })}
        {renderSubNavItem({
          id: "investigatingLeads",
          index: "ii.",
          label: "Investigations",
        })}
        {renderSubNavItem({
          id: "closingLeads",
          index: "iii.",
          label: "Closing Investigations",
        })}
      </GuideSubNavGroup>

      {renderNavItem({
        id: "performance",
        label: "Performance Metrics",
        icon: <QueryStatsIcon />,
        active: navSelection === "performance",
        onClick: () => changeSelection(false, "performance"),
      })}
      {renderNavItem({
        id: "repository",
        label: "Mortgage Repository",
        icon: <ListIcon />,
        active: navSelection === "repository",
        onClick: () => changeSelection(false, "repository"),
      })}
      {renderNavItem({
        id: "configuration",
        label: "System Configuration",
        icon: <BuildCircleIcon />,
        active: navSelection === "configuration",
        onClick: () => changeSelection(false, "configuration"),
      })}
      {renderNavItem({
        id: "propertySearch",
        label: "Property Search",
        icon: <SearchIcon />,
        active: navSelection === "propertySearch",
        onClick: () => changeSelection(false, "propertySearch"),
      })}
      {renderNavItem({
        id: "reports",
        label: "Report Generation",
        icon: <ArticleIcon />,
        active: navSelection === "reports",
        onClick: () => changeSelection(false, "reports"),
      })}
      {renderNavItem({
        id: "notifications",
        label: "Notification System",
        icon: <NotificationsIcon />,
        active: navSelection === "notifications",
        onClick: () => changeSelection(false, "notifications"),
      })}
      {renderNavItem({
        id: "settings",
        label: "Settings",
        icon: <SettingsIcon />,
        active: navSelection === "settings",
        onClick: () => changeSelection(false, "settings"),
      })}
    </GuideNavList>
  )
}

export default GuideNavigation
